import type { Crop } from "@ext/markdown/elements/image/edit/model/imageEditorTypes";
import getVideoLayout from "@ext/markdown/elements/video/logic/getVideoLayout";

export interface GalleryItemAttrs {
	path?: string;
	width?: string | null;
	height?: string | null;
	crop?: Crop | null;
}

export interface GalleryItem {
	ratio: number;
}

const UNKNOWN_RATIO = 1;
const LANDSCAPE_VIDEO_RATIO = 16 / 9;
const PORTRAIT_VIDEO_RATIO = 9 / 16;

const getGalleryItemRatio = ({ path, width, height, crop }: GalleryItemAttrs): number => {
	if (path) return getVideoLayout(path) === "vertical" ? PORTRAIT_VIDEO_RATIO : LANDSCAPE_VIDEO_RATIO;

	const croppedWidth = parseFloat(width) * ((crop?.w ?? 100) / 100);
	const croppedHeight = parseFloat(height) * ((crop?.h ?? 100) / 100);
	const ratio = croppedWidth / croppedHeight;
	return Number.isFinite(ratio) && ratio > 0 ? ratio : UNKNOWN_RATIO;
};

export const toGalleryItem = (attrs: GalleryItemAttrs): GalleryItem => ({
	ratio: getGalleryItemRatio(attrs),
});

const MIN_CAROUSEL_RATIO = 4 / 3;
const MAX_CAROUSEL_RATIO = 16 / 9;

export const getCarouselRatio = (ratios: number[]) =>
	Math.min(Math.max(Math.max(...ratios), MIN_CAROUSEL_RATIO), MAX_CAROUSEL_RATIO);

export default getGalleryItemRatio;
